import { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
import { useTrackImpressionEventByIntersection } from "~/lib/hooks";
import { useMiniHeaderIndicatorContext } from "./subscription-button/context";
export const useGA4CommonParameters = () => {
  const {
    currentArticleId,
    rosettaInstance
  } = useSdkContext();
  const computeGA4CommonParameters = useCallback(() => {
    var _searchParameters$get;
    if (!rosettaInstance) return {};
    const searchParameters = new URLSearchParams(window.location.search);
    const promoCode = (_searchParameters$get = searchParameters.get("promoCode")) !== null && _searchParameters$get !== void 0 ? _searchParameters$get : "";
    const baseParameters = rosettaInstance.rulesEngine.getOutcome("tracking.ga4.baseParameters");
    const parameters = {
      ...baseParameters,
      ...(currentArticleId ? {
        article_id: currentArticleId
      } : {}),
      ...(promoCode ? {
        promo_code: promoCode
      } : {})
    };
    return parameters;
  }, [currentArticleId, rosettaInstance]);
  return {
    computeGA4CommonParameters
  };
};
export const useSendImpressionEvents = parameters => {
  const {
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  const {
    inMiniHeader
  } = useMiniHeaderIndicatorContext();
  const {
    ga4Event,
    gaEvent
  } = parameters;
  const {
    captureTrackImpressionEventTargetElement,
    intersection
  } = useTrackImpressionEventByIntersection({
    ga4TrackingHandler: handleTrackGA4,
    gaTrackingHandler: handleTrackGA,
    getEvent: gaEvent,
    getGa4Event: ga4Event,
    options: {
      intersectionThreshold: [0.5],
      isSendGA4Tracking: !inMiniHeader,
      isSendGATracking: !inMiniHeader,
      shouldSendOnce: true
    }
  });
  return {
    captureTrackImpressionEventTargetElement,
    intersection
  };
};